import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { toast, ToastContainer } from "react-toastify";
import { getTrans as t } from "../../../Localization/translations";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const AddTermCondition = ({ contract_id, onClose, refresh }) => {
  const form = useRef();
  const checkBtn = useRef();
  const [termsList, setTermsList] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    value: "",
    contract: contract_id,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    axios
      .get(`${API}company/term-conditions/`, {
        headers: authHeader(),
      })
      .then((res) => {
        setTermsList(res.data || []);
      })
      .catch(() => toast.error("Failed to load terms list"));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {

      const payload = {
        ...formData,
        contract: contract_id, // ✅ ALWAYS set here
      };

      axios
        .post(`${API}contracts/terms/create/`, payload, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data.success === 1) {
            toast.success("Term added successfully");

            refresh();

            setTimeout(() => {
              onClose();
            }, 1000); 
          }
        })
        .catch(() => toast.error("Error adding term"));
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="row py-2">
        <div className="col-md-12">
          {/* ✅ HEADER SAME AS PARTY ROLE */}
          <div className="header pb-0 mb-2">
            <h5 className="mb-0">{t("Add Term & Condition")}</h5>
          </div>

          {/* ✅ CARD SAME */}
          <div className="card">
            <div className="card-body">

              <Form ref={form} onSubmit={handleSubmit}>

                <div className="row">

                  {/* NAME */}
                  <div className="col-md-6 mt-2">
                    <label className="col-form-label required">
                      {t("Name")}{" "}
                      <Tooltip content={t("Name_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>

                    <select
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => {
                        const selectedName = e.target.value;

                        const selected = termsList.find((t) => t.name === selectedName);

                        setFormData({
                          ...formData,
                          name: selectedName,
                          value: selected?.value || "", // auto-fill value
                        });
                      }}
                    >
                      <option value="">{t("Select")}</option>

                      {termsList.map((term) => (
                        <option key={term.id} value={term.name}>
                          {term.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* VALUE */}
                  <div className="col-md-6 mt-2">
                    <label className="col-form-label required">
                      {t("Value")}{" "}
                      <Tooltip content={t("Value_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>

                    <textarea
                      name="value"
                      className="form-control"
                      value={formData.value}
                      onChange={handleChange}
                    />
                  </div>

                  {/* BUTTONS */}
                  <div className="col-md-12">
                    <div className="ms-auto my-auto mt-3">

                      <button
                        type="button"
                        className="btn btn-secondary mb-0"
                        onClick={onClose}
                        style={{ marginRight: "10px" }}
                      >
                        {t("Cancel")}
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary mb-0"
                        onClick={handleSubmit}
                      >
                        {t("Save")}
                      </button>

                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </div>
                  </div>

                </div>
              </Form>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTermCondition;